import * as React from "react";
import { IReduxProps, IOwnProps } from "../pinned-row-constants";
import { setCurrency } from "../pinned-row-helpers";
import { getColumnComponent } from "./totals-renderers-helpers";
export const TotalsRollupRenderer: React.FunctionComponent<IReduxProps & IOwnProps> = ({
    colDef,
    kind,
    columnApi,
    style,
    allocationReferenceFields,
    total,
    plan,
    totalType,
}) => {
    const fieldName = colDef.colId;
    const Component = getColumnComponent(kind, fieldName);
    const currency = setCurrency(
        totalType,
        allocationReferenceFields,
        columnApi,
        !!colDef?.cellRendererParams?.doors,
        kind,
        colDef?.cellRendererParams?.currency
    );

    return (
        <Component
            fieldName={fieldName}
            totalType={totalType}
            style={style}
            currency={currency}
            total={total}
            plan={plan}
        />
    );
};
